import { Box, Typography } from "@mui/material";

const AppLoader = ({ message = "Loading Pitchest..." }) => (
  <Box
    sx={{
      height: "100vh",
      width: "100vw",
      background: "linear-gradient(135deg, #7f5af0, #c866e0)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
      fontFamily: "'Inter', sans-serif",
      fontSize: "1.5rem",
      zIndex: 9999,
    }}
  >
    <Box
      sx={{
        width: 60,
        height: 60,
        border: "6px solid #fff",
        borderTop: "6px solid transparent",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
        mb: 2,
      }}
    />
    <Typography>{message}</Typography>
    <style>{`
      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    `}</style>
  </Box>
);

export default AppLoader;
